module.exports = __webpack_public_path__ + "img/lg_ring_y_s_null_1@2x.d0e4d18c.png";